import React from 'react';

/**
 * Identificador que abre carga, pré-carga ou viagem em nova aba. Não usa Link/useHref: em
 * navegações do Kanban os hooks do router liam o contexto de localização vazio e desmontavam a
 * tela. Nova aba não usa navegação interna e o app não tem basename, então o href é o caminho.
 */
export default function IdentityLink({ to, children, ...props }) {
  return (
    <a
      className="tc-k-identity-link"
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
}
